module.exports = __webpack_public_path__ + "static/media/exercicios.f0424956.png";